import type { QueryState } from 'enable-ui';

import { ReactComponent as SortASCIcon } from '../../assets/icons/sort-asc-12.svg';
import { ReactComponent as SortDefaultIcon } from '../../assets/icons/sort-default-12.svg';
import { ReactComponent as SortDESCIcon } from '../../assets/icons/sort-desc-12.svg';

export const iconSort = {
  default: <SortDefaultIcon style={{ height: '100%' }} />,
  asc: <SortASCIcon style={{ height: '100%' }} />,
  desc: <SortDESCIcon style={{ height: '100%' }} />,
};

export const deleteDefaultQueryStateFromTable = (queryState: QueryState) => {
  const newQueryState = { ...queryState };

  if (newQueryState?.orderBy === 'createdAt' && newQueryState?.orderDirection === 'DESC') {
    delete newQueryState.orderBy;
    delete newQueryState.orderDirection;
  }

  return newQueryState;
};
